module.exports = __webpack_public_path__ + "static/media/1.76a456b6.jpeg";